module.exports = __webpack_public_path__ + "media/images/browser-icon-chrome-ea05d08af5c2a4eafa318b491da7df2a.png";